import axios from "axios";
import { useFormik } from "formik";
import { enqueueSnackbar } from "notistack";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { API } from "../../helpers/constants";
import { handleAxiosErrors } from "../../helpers/errorHandling";
import { GENERAL_SETTINGS } from "../../locales/components/namespaces";
import useUserData from "../user/useUserData";
import * as yup from 'yup'

export const useCoorganizationForm = (options) => {
	const { coorganizationId, onSuccess = () => {}, mainExhibitionId, coorganizationExhibitions, descriptionEl, descriptionEn} = options
	const { t } = useTranslation(GENERAL_SETTINGS)
	const { token } = useUserData()
	const [loadingSubmit, setLoadingSubmit] = useState(false)
	
	const onSubmit = (values) => {
		setLoadingSubmit(true)
		axios({
			url: coorganizationId ? `${API}/en/coorganization/update/${coorganizationId}` : `${API}/en/coorganization/store`,
			method: 'post',
			data: {
				DescriptionEN: values.descriptionEn,
				DescriptionEL: values.descriptionEl,
				exhibitions: values.exhibitions?.map(i => i.id),
				mainExhibitionId: values.mainExhibitionId,
			},
			headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
		}).then(response => {
			setLoadingSubmit(false)
			enqueueSnackbar(t(coorganizationId ? 'Coorganization updated successfully!' : 'Coorganization stored successfully!'), {
				variant: 'success'
			})
			onSuccess()
		}).catch((error) => {
			setLoadingSubmit(false)
			enqueueSnackbar(handleAxiosErrors(error), {
				variant: 'error',
				autoHideDuration: null,
			})
		})
	}
	
	const validationSchema = yup.object().shape({
		descriptionEn: yup.string().required(t('Required')),
		descriptionEl: yup.string().required(t('Required')),
		exhibitions: yup.array().min(2).required(t("Select at least 2 exhibitions to create a coorganization.")),
		mainExhibitionId: yup.string().required(t('Required'))
	})
	
	const formik = useFormik({
		initialValues: {
			descriptionEn: coorganizationId ? descriptionEn : '',
			descriptionEl: coorganizationId ? descriptionEl : '',
			exhibitions: coorganizationId ? coorganizationExhibitions : [],
			mainExhibitionId: coorganizationId ? mainExhibitionId : '',
		},
		validationSchema: validationSchema,
		onSubmit: onSubmit,
	})
	
	return {
		formik,
		loadingSubmit
	}
	
}